import React from 'react';

const Impact = () => {
  return (
    <main>
      <section className="impact section" style={{paddingTop: '8rem', background: 'white', padding: '8rem 0 6rem 0'}}>
        <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '0 1rem', width: '100%', boxSizing: 'border-box'}}>
          <div className="section-title" style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h1 style={{ 
              fontWeight: 800, 
              marginBottom: '2rem', 
              fontSize: 'clamp(2.5rem, 5vw, 4rem)',
              color: '#AA5B52'
            }}>Our Impact</h1>
            <p style={{ 
              fontSize: 'clamp(1.1rem, 3vw, 1.6rem)', 
              lineHeight: 1.6, 
              maxWidth: '850px', 
              margin: '0 auto 3.5rem',
              color: '#666',
              padding: '0 1rem'
            }}>Afterimage is making healthcare safer by addressing the critical issue of diagnostic errors.</p>
          </div>
          
          <div className="stats-grid" style={{
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
            gap: '2rem', 
            padding: '0 1rem',
            marginBottom: '3rem'
          }}>
            <div className="stat-card" style={{ 
              boxShadow: '0 8px 25px rgba(170,91,82,0.08)', 
              padding: 'clamp(2rem, 4vw, 2.5rem)',
              background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
              borderRadius: '2rem',
              textAlign: 'center',
              border: '1px solid #e3f2fd'
            }}>
              <div className="stat-number" style={{ 
                fontSize: 'clamp(3rem, 6vw, 4.5rem)', 
                fontWeight: 800, 
                marginBottom: '1rem',
                color: '#2D5B7B'
              }}>20%</div>
              <p style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                lineHeight: 1.7, 
                color: '#444'
              }}>of patients experience diagnostic errors during their care, with most being relatively minor</p>
            </div>
            <div className="stat-card" style={{ 
              boxShadow: '0 8px 25px rgba(255,193,7,0.08)', 
              padding: 'clamp(2rem, 4vw, 2.5rem)',
              background: 'linear-gradient(135deg, #fff8e1 0%, #fff3c4 100%)',
              borderRadius: '2rem',
              textAlign: 'center',
              border: '1px solid #ffe082'
            }}>
              <div className="stat-number" style={{ 
                fontSize: 'clamp(3rem, 6vw, 4.5rem)', 
                fontWeight: 800, 
                marginBottom: '1rem',
                color: '#f57c00'
              }}>1M+</div>
              <p style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                lineHeight: 1.7, 
                color: '#444'
              }}>patients face permanent disability or death from diagnostic errors annually, yet only 5-10k cases are investigated</p>
            </div>
            <div className="stat-card" style={{ 
              boxShadow: '0 8px 25px rgba(170,91,82,0.08)', 
              padding: 'clamp(2rem, 4vw, 2.5rem)',
              background: 'linear-gradient(135deg, #f3e5f5 0%, #e8eaf6 100%)',
              borderRadius: '2rem',
              textAlign: 'center',
              border: '1px solid #d1c4e9'
            }}>
              <div className="stat-number" style={{ 
                fontSize: 'clamp(3rem, 6vw, 4.5rem)', 
                fontWeight: 800, 
                marginBottom: '1rem',
                color: '#AA5B52'
              }}>$300B+</div>
              <p style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                lineHeight: 1.7, 
                color: '#444'
              }}>in preventable healthcare costs from medical errors are borne by patients and insurance every year</p>
            </div>
          </div>
          
          <div className="stat-card" style={{ 
            margin: '4rem auto', 
            maxWidth: '850px', 
            textAlign: 'center', 
            padding: 'clamp(2rem, 4vw, 3rem)', 
            boxShadow: '0 8px 25px rgba(170,91,82,0.08)',
            background: 'linear-gradient(135deg, #fff8f5 0%, #f7e6e1 100%)',
            borderRadius: '2rem',
            border: '1px solid #f0f0f0'
          }}>
            <p style={{ 
              fontSize: 'clamp(1.2rem, 3vw, 1.5rem)', 
              fontWeight: 600, 
              color: '#AA5B52', 
              marginBottom: '1.5rem'
            }}>Today, 95% of patients are told "sorry, can't help" on the first call to an attorney, and most victims don't even call.</p>
            <p style={{ 
              fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
              lineHeight: 1.7, 
              color: '#444'
            }}>Why? High investigation costs, risk of failure, few experienced medical malpractice attorneys, fear of lawsuits, and distrust of attorneys create barriers to justice.</p>
          </div>
          
          <div className="testimonial" style={{ 
            padding: 'clamp(2rem, 4vw, 4rem)', 
            boxShadow: '0 8px 25px rgba(45,91,123,0.08)',
            background: 'linear-gradient(135deg, #e8f4f8 0%, #fff 100%)',
            borderRadius: '2rem',
            border: '1px solid #e3f2fd'
          }}>
            <p className="testimonial-content" style={{ 
              fontSize: 'clamp(1.1rem, 3vw, 1.6rem)', 
              lineHeight: 1.7, 
              fontWeight: 500,
              color: '#444',
              fontStyle: 'italic'
            }}>"After being suddenly diagnosed with stage IV cancer despite regular screenings, I was devastated. Afterimage helped me discover that signs of my tumor were visible in previous scans but had been overlooked. Their support was invaluable in helping me get the compensation I needed for my care, but more importantly, they're working to prevent this from happening to others."</p>
            <div className="testimonial-author" style={{ 
              marginTop: '2rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem'
            }}>
              <div className="testimonial-avatar" style={{ 
                width: 'clamp(60px, 10vw, 70px)', 
                height: 'clamp(60px, 10vw, 70px)', 
                backgroundColor: '#2D5B7B', 
                borderRadius: '50%',
                boxShadow: '0 5px 15px rgba(45,91,123,0.2)'
              }}></div>
              <div>
                <h4 style={{ 
                  fontSize: 'clamp(1.2rem, 3vw, 1.4rem)', 
                  marginBottom: '0.5rem', 
                  fontWeight: 700,
                  color: '#2D5B7B'
                }}>Sarah J.</h4>
                <p style={{ 
                  fontSize: 'clamp(1rem, 2.5vw, 1.15rem)', 
                  fontWeight: 500,
                  color: '#666'
                }}>Patient Advocate</p>
              </div>
            </div>
          </div>
          
          <div style={{marginTop: '6rem'}}>
            <h2 style={{ 
              textAlign: 'center', 
              marginBottom: '3.5rem', 
              fontWeight: 700, 
              fontSize: 'clamp(2rem, 4vw, 3.2rem)',
              color: '#AA5B52'
            }}>How We're Making a Difference</h2>
            
            <div style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
              gap: 'clamp(2rem, 4vw, 3rem)',
              padding: '0 1rem'
            }}>
              <div style={{
                backgroundColor: 'white', 
                padding: 'clamp(2rem, 4vw, 3rem)', 
                borderRadius: '2rem', 
                boxShadow: '0 8px 25px rgba(170,91,82,0.08)',
                border: '1px solid #f0f0f0'
              }}>
                <h3 style={{ 
                  fontSize: 'clamp(1.3rem, 3vw, 2.1rem)', 
                  marginBottom: '1.5rem', 
                  fontWeight: 700,
                  color: '#2D5B7B'
                }}>For Patients</h3>
                <ul style={{
                  marginLeft: '1.5rem', 
                  fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                  lineHeight: 1.8,
                  color: '#444'
                }}>
                  <li>Simplified access to expert review of medical records</li>
                  <li>Clear understanding of potential diagnostic errors</li>
                  <li>Advocacy throughout the medical and legal process</li>
                  <li>Fair compensation for harm caused by medical errors</li>
                </ul>
              </div>
              
              <div style={{
                backgroundColor: 'white', 
                padding: 'clamp(2rem, 4vw, 3rem)', 
                borderRadius: '2rem', 
                boxShadow: '0 8px 25px rgba(45,91,123,0.08)',
                border: '1px solid #f0f0f0'
              }}>
                <h3 style={{ 
                  fontSize: 'clamp(1.3rem, 3vw, 2.1rem)', 
                  marginBottom: '1.5rem', 
                  fontWeight: 700,
                  color: '#f57c00'
                }}>For Healthcare Systems</h3>
                <ul style={{
                  marginLeft: '1.5rem', 
                  fontSize: 'clamp(1rem, 2.5vw, 1.25rem)', 
                  lineHeight: 1.8,
                  color: '#444'
                }}>
                  <li>Identification of systemic issues before they cause widespread harm</li>
                  <li>Data-driven insights for quality improvement</li>
                  <li>Reduction in overall malpractice risk through preventative measures</li>
                  <li>Better patient outcomes and satisfaction</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Impact; 